import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import moment from 'moment';
import { finalize, forkJoin, of, Subject, takeUntil, tap } from 'rxjs';
import { SalesService } from 'src/app/services/api/sales.service';

@Component({
  selector: 'app-dialog-file-detail',
  templateUrl: './dialog-file-detail.component.html',
  styleUrls: ['./dialog-file-detail.component.scss'],
})
export class DialogFileDetailComponent implements OnInit, OnDestroy {
  private _unsuscribeOnDestroy$: Subject<boolean> = new Subject<boolean>();

  loading: boolean = true;
  dataServices: any[] = [];
  dataSource: any;
  passengers: any[] = [];
  restriccionesAlimenticias: boolean = false;
  displayedColumns: string[] = ['day', 'fecha', 'nombre', 'tipo', 'categoria'];

  selectTipo: string | null = null;
  arrayTipos: any = [];
  selectCategoria: string | null = null;
  arrayCategorias: any = [];

  paginator!: MatPaginator;
  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.dataSource.paginator = this.paginator;
  }

  constructor(
    private salesService: SalesService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<DialogFileDetailComponent>,
  ) {}

  ngOnInit(): void {
    this.dataSource = new MatTableDataSource();
    this.loading = true;

    forkJoin([this.getAllServices(), this.obtenerRestriccionesAlimenticias()])
      .pipe(
        takeUntil(this._unsuscribeOnDestroy$),
        finalize(() => (this.loading = false)),
      )
      .subscribe();
  }
  ngOnDestroy(): void {
    this._unsuscribeOnDestroy$.next(true);
  }
  getAllServices() {
    return this.salesService.getServicesByFile(this.data.file.id).pipe(
      takeUntil(this._unsuscribeOnDestroy$),
      tap((res: any) => {
        this.dataServices = res.getServicesByFile;

        this.dataServices.sort((a, b) => {
          const dayA = parseInt(a.day, 10);
          const dayB = parseInt(b.day, 10);

          return dayA - dayB;
        });

        const tipo = this.dataServices
          .filter((el: any) => el.tipoServicio)
          .map((item: any) => item.tipoServicio);
        this.arrayTipos = [...new Set(tipo)];

        const categoria = this.dataServices
          .filter(
            (el: any) =>
              el.categoriaServicio !== null && el.categoriaServicio !== 'null',
          )
          .map((item: any) => item.categoriaServicio);
        this.arrayCategorias = [...new Set(categoria)];

        this.dataSource.data = this.dataServices;
        this.dataSource.paginator = this.paginator;
      }),
    );
  }

  obtenerRestriccionesAlimenticias() {
    const hasPassenger = this.data.file.lstPaX.some(
      (passenger: any) => passenger?.passengerId,
    );

    if (!hasPassenger) {
      this.restriccionesAlimenticias = false;
      return of(null);
    }

    return this.salesService
      .getPassengersByIds({
        passengerIds: this.data.file.lstPaX
          .filter((pax: any) => pax?.passengerId && !!pax?.estado)
          .map((pax: any) => pax?.passengerId),
        passengerFields: {
          id: true,
          firstName: true,
          lastName: true,
          restriccionesAlimentarias: true,
        },
      })
      .pipe(
        tap({
          next: (res: any) => {
            this.passengers = res.getPassengers;
            this.restriccionesAlimenticias = true;
          },
          error: (unknownError: any) => {
            console.error('Error fetching passenger data:', unknownError);
          },
        }),
      );
  }

  showDate(day: string) {
    const fechaInicio = moment(this.data.file.dateRange, 'DD.MM.YYYY').toDate();
    fechaInicio.setDate(fechaInicio.getDate() + parseInt(day) - 1);
    return fechaInicio;
  }

  applyFilterSelect() {
    let dataNew: any = this.dataServices;
    if (this.selectCategoria) {
      dataNew = dataNew?.filter(
        (item: any) => item.categoriaServicio === this.selectCategoria,
      );
    }

    if (this.selectTipo) {
      dataNew = dataNew?.filter(
        (item: any) => item.tipoServicio === this.selectTipo,
      );
    }

    this.dataSource.data = dataNew;
  }
}
